import { useState } from 'react';
import * as CONST from '../Constants.js';
import '../App.css';

function YouTubeEmbed({ id, title, language }) {
  const [isLoaded, setIsLoaded] = useState(false);

  const videoBoxStyle = {
    width: '560px',
    maxWidth: '100%',
    aspectRatio: '16 / 9',
    borderRadius: '10px',
    boxSizing: 'border-box'
  };

  if (!isLoaded) {
    return (
      <div
        role="group"
        aria-label={title}
        style={{
          ...videoBoxStyle,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '14px',
          padding: '20px',
          textAlign: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.28)',
          border: '1px solid rgba(237, 125, 49, 0.65)'
        }}
      >
        <p style={{
          margin: 0,
          maxWidth: '450px',
          fontSize: '0.86em',
          lineHeight: 1.45
        }}>
          {language
            ? 'This video is embedded from YouTube. It will only load after your click; data may then be transferred to Google/YouTube.'
            : 'Dieses Video ist von YouTube eingebettet. Es wird erst nach Ihrem Klick geladen; dabei können Daten an Google/YouTube übertragen werden.'}
        </p>
        <button
          type="button"
          onClick={() => setIsLoaded(true)}
          style={{
            padding: '9px 16px',
            border: 'none',
            borderRadius: '6px',
            backgroundColor: '#ED7D31',
            color: '#111',
            cursor: 'pointer',
            fontFamily: 'Inter',
            fontWeight: 700,
            fontSize: '0.9em'
          }}
        >
          {language ? 'Load video' : 'Video laden'}
        </button>
      </div>
    );
  }

  return (
    <iframe
      width="560"
      height="315"
      src={`https://www.youtube-nocookie.com/embed/${id}?rel=0`}
      title={title}
      loading="lazy"
      referrerPolicy="strict-origin-when-cross-origin"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
      style={{
        ...videoBoxStyle,
        border: 0
      }}
    />
  );
}

export default function VideoScreen({
  language
}) {

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      marginTop: CONST.MARGINGROSS,
      justifyContent: 'center',
      alignItems: 'center',
      fontFamily: 'Inter', 
      fontSize: CONST.SCHRIFTGROSS,
      color: 'white',
      padding: '20px',
      maxWidth: '1200px',
      margin: '0 auto'
    }}>
      <div style={{ width: '100%', color: 'white', alignItems: 'center' }}>
        
        <h1 style={{ 
          textAlign: 'center', 
          color: '#ED7D31',
          marginBottom: '30px',
          fontSize: '2.5em'
        }}>
          {language ? 'Therapeutic Drug Monitoring in Clinical Practice' : 'Therapeutisches Drug Monitoring in der klinischen Praxis'}
        </h1>

        <div style={{ 
          textAlign: 'center', 
          marginBottom: '30px',
          fontSize: '1.2em',
          lineHeight: '1.6'
        }}>
          <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>
            {language ? 'Learning Videos with Examples from Daily Practice' : 'Lernvideos mit Beispielen aus dem Alltag'}
          </p>
          <p style={{ marginBottom: '10px' }}>
            {language ? 'by Dr. Ute Chiriac & Dr. Otto Frey' : 'von Dr. Ute Chiriac & Dr. Otto Frey'}
          </p>
          <p style={{ fontStyle: 'italic', fontSize: '0.9em' }}>
            {language ? '(Produced with support from Roche)' : '(Produziert mit Unterstützung von Roche)'}
          </p>
        </div>

        <div style={{ 
          marginBottom: '40px',
          padding: '20px',
          backgroundColor: 'rgba(237, 125, 49, 0.1)',
          borderRadius: '10px',
          lineHeight: '1.6'
        }}>
          <p>
            {language 
              ? 'In these learning videos, we would like to provide practical insights into Therapeutic Drug Monitoring (TDM) and present tools that facilitate clinical daily practice. The videos are modularly structured and can be viewed independently. This allows you to specifically select the topics that are particularly relevant for your daily work.'
              : 'In den Lernvideos möchten wir praxisnahe Einblicke in das Therapeutische Drug Monitoring (TDM) geben und Werkzeuge vorstellen, die den klinischen Alltag erleichtern. Die Videos sind modular aufgebaut und können unabhängig voneinander angeschaut werden. So können gezielt die Themen ausgewählt werden, die für Ihre tägliche Arbeit besonders relevant sind.'
            }
          </p>
        </div>

        {/* Modul 1 */}
        <div style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: '#ED7D31', 
            fontSize: '1.8em',
            marginBottom: '20px',
            borderBottom: '2px solid #ED7D31',
            paddingBottom: '10px'
          }}>
            {language ? 'Module 1: Hello and Welcome' : 'Modul 1: Hallo und herzlich Willkommen'}
          </h2>
          
          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ 
              fontSize: '1.3em', 
              marginBottom: '15px',
              color: '#FFF'
            }}>
              {language 
                ? 'Lesson 1 - Get to know Dr. Ute Chiriac and Dr. Otto Frey, who will guide you through the learning videos.'
                : 'Lektion 1 - Lernen Sie Dr. Ute Chiriac und Dr. Otto Frey kennen, die Sie durch die Lernvideos begleiten.'
              }
            </h3>
            <div style={{ 
              display: 'flex', 
              flexWrap: 'wrap',
              gap: '20px',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              <YouTubeEmbed
                id="JQQwLdEyuQk"
                title={language ? "Introduction Video 1" : "Einführungsvideo 1"}
                language={language}
              />
              <YouTubeEmbed
                id="Nrj9Zi1tEJw"
                title={language ? "Introduction Video 2" : "Einführungsvideo 2"}
                language={language}
              />
            </div>
          </div>
        </div>

        {/* Modul 2 */}
        <div style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: '#ED7D31', 
            fontSize: '1.8em',
            marginBottom: '20px',
            borderBottom: '2px solid #ED7D31',
            paddingBottom: '10px'
          }}>
            {language ? 'Module 2: From Basics to Practice' : 'Modul 2: Von den Grundlagen zur Praxis'}
          </h2>
          
          {/* Lektion 2 */}
          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ 
              fontSize: '1.3em', 
              marginBottom: '10px',
              color: '#FFF'
            }}>
              {language 
                ? 'Lesson 2 - Therapeutic Drug Monitoring (TDM) of Antibiotics: Overview and Fundamentals'
                : 'Lektion 2 - Therapeutisches Drug Monitoring (TDM) von Antibiotika: Überblick und Grundlagen'
              }
            </h3>
            <p style={{ marginBottom: '15px', fontSize: '0.9em' }}>
              {language 
                ? 'Learn what TDM means and which central elements belong to it.'
                : 'Lernen Sie, was man unter TDM versteht und welche zentralen Elemente dazugehören.'
              }
            </p>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <YouTubeEmbed
                id="B0ARazLSWx4"
                title={language ? "TDM Antibiotics Overview" : "TDM Antibiotika Überblick"}
                language={language}
              />
            </div>
          </div>

          {/* Lektion 3 */}
          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ 
              fontSize: '1.3em', 
              marginBottom: '10px',
              color: '#FFF'
            }}>
              {language 
                ? 'Lesson 3 - Pharmacokinetics and Pharmacodynamics: How do Antibiotics Work?'
                : 'Lektion 3 - Pharmakokinetik und Pharmakodynamik: Wie wirken Antibiotika?'
              }
            </h3>
            <p style={{ marginBottom: '15px', fontSize: '0.9em' }}>
              {language 
                ? 'Learn how antibiotics work in the body and why understanding PK/PD is crucial for successful TDM.'
                : 'Lernen Sie, wie Antibiotika im Körper wirken und warum das Verständnis von PK/PD für ein erfolgreiches TDM entscheidend ist.'
              }
            </p>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <YouTubeEmbed
                id="Ta0rOeppjyo"
                title={language ? "Pharmacokinetics and Pharmacodynamics" : "Pharmakokinetik und Pharmakodynamik"}
                language={language}
              />
            </div>
          </div>

          {/* Lektion 4 */}
          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ 
              fontSize: '1.3em', 
              marginBottom: '10px',
              color: '#FFF'
            }}>
              {language 
                ? 'Lesson 4 - In which situations and for which target groups is TDM useful?'
                : 'Lektion 4 - In welchen Situationen und für welche Zielgruppen ist TDM sinnvoll?'
              }
            </h3>
            <p style={{ marginBottom: '15px', fontSize: '0.9em' }}>
              {language 
                ? 'Learn for which patient groups and indications TDM is particularly important and why there is a special benefit there.'
                : 'Lernen Sie, für welche Patientengruppen und Indikationen TDM besonders wichtig ist und warum gerade dort ein besonderer Nutzen besteht.'
              }
            </p>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <YouTubeEmbed
                id="WdLMESJMsMc"
                title={language ? "TDM Situations and Target Groups" : "TDM Situationen und Zielgruppen"}
                language={language}
              />
            </div>
          </div>

          {/* Lektion 5 */}
          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ 
              fontSize: '1.3em', 
              marginBottom: '10px',
              color: '#FFF'
            }}>
              {language 
                ? 'Lesson 5 - TDM Planning: Effective Dose Calculation with Modern Dosing Tools'
                : 'Lektion 5 - TDM-Planung: Effektive Dosiskalkulation mit modernen Dosierungstools'
              }
            </h3>
            <p style={{ marginBottom: '15px', fontSize: '0.9em' }}>
              {language 
                ? 'Learn different approaches to dose calculation with their advantages and disadvantages.'
                : 'Lernen Sie unterschiedliche Ansätze zur Dosiskalkulation mit ihren Vor- und Nachteilen kennen.'
              }
            </p>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <YouTubeEmbed
                id="lL0wwNj6Ulc"
                title={language ? "TDM Planning and Dose Calculation" : "TDM Planung und Dosiskalkulation"}
                language={language}
              />
            </div>
          </div>

          {/* Lektion 6 */}
          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ 
              fontSize: '1.3em', 
              marginBottom: '10px',
              color: '#FFF'
            }}>
              {language 
                ? 'Lesson 6 - Avoiding Pitfalls in Sample Handling and Administration'
                : 'Lektion 6 - Fallstricke vermeiden bei Probenhandling und Verabreichung'
              }
            </h3>
            <p style={{ marginBottom: '15px', fontSize: '0.9em' }}>
              {language 
                ? 'Learn why stability in sample collection and drug administration is crucial for the significance of TDM.'
                : 'Lernen Sie, warum Stabilität bei Probenentnahme und bei der Arzneimittelverabreichung entscheidend für die Aussagekraft des TDM ist.'
              }
            </p>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <YouTubeEmbed
                id="gsfyOwjj09U"
                title={language ? "Sample Handling and Administration" : "Probenhandling und Verabreichung"}
                language={language}
              />
            </div>
          </div>

          {/* Lektion 7 */}
          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ 
              fontSize: '1.3em', 
              marginBottom: '10px',
              color: '#FFF'
            }}>
              {language 
                ? 'Lesson 7 - TDM in Practice - Clearing Obstacles from the Way'
                : 'Lektion 7 - TDM in der Anwendung - Stolpersteine aus dem Weg räumen'
              }
            </h3>
            <p style={{ marginBottom: '15px', fontSize: '0.9em' }}>
              {language 
                ? 'Learn to recognize and overcome common challenges in clinical practice.'
                : 'Lernen Sie, häufige Herausforderungen im klinischen Alltag zu erkennen und zu überwinden.'
              }
            </p>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <YouTubeEmbed
                id="94VAbRX9NYE"
                title={language ? "TDM in Practice - Overcoming Challenges" : "TDM in der Anwendung - Herausforderungen überwinden"}
                language={language}
              />
            </div>
          </div>

          {/* Lektion 8 */}
          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ 
              fontSize: '1.3em', 
              marginBottom: '10px',
              color: '#FFF'
            }}>
              {language 
                ? 'Lesson 8 - TDM is Teamwork - Collaboration Across Professional Groups'
                : 'Lektion 8 - TDM ist Teamwork - Zusammenarbeit über Berufsgruppen hinweg'
              }
            </h3>
            <p style={{ marginBottom: '15px', fontSize: '0.9em' }}>
              {language 
                ? 'Learn who is involved in TDM and why interprofessional collaboration is essential for success.'
                : 'Lernen Sie, wer am TDM beteiligt ist und warum interprofessionelle Zusammenarbeit für den Erfolg unerlässlich ist.'
              }
            </p>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <YouTubeEmbed
                id="kXmGtefM3Z4"
                title={language ? "TDM Teamwork and Collaboration" : "TDM Teamwork und Zusammenarbeit"}
                language={language}
              />
            </div>
          </div>
        </div>

        {/* Modul 3 */}
        <div style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: '#ED7D31', 
            fontSize: '1.8em',
            marginBottom: '20px',
            borderBottom: '2px solid #ED7D31',
            paddingBottom: '10px'
          }}>
            {language ? 'Module 3: EasyCalculator Step by Step' : 'Modul 3: EasyRechner Schritt für Schritt'}
          </h2>
          
          {/* Lektion 9 */}
          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ 
              fontSize: '1.3em', 
              marginBottom: '10px',
              color: '#FFF'
            }}>
              {language 
                ? 'Lesson 9 - TDM of Vancomycin'
                : 'Lektion 9 - TDM von Vancomycin'
              }
            </h3>
            <p style={{ marginBottom: '15px', fontSize: '0.9em' }}>
              {language 
                ? 'Learn to know and apply the VancoEasy calculator step by step using clinical case examples with vancomycin.'
                : 'Lernen Sie den VancoEasy-Rechner Schritt für Schritt anhand klinischer Fallbeispiele mit Vancomycin kennen und anwenden.'
              }
            </p>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <YouTubeEmbed
                id="7GZUF-2uxT0"
                title={language ? "TDM Vancomycin with VancoEasy" : "TDM Vancomycin mit VancoEasy"}
                language={language}
              />
            </div>
          </div>

          {/* Lektion 10 */}
          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ 
              fontSize: '1.3em', 
              marginBottom: '10px',
              color: '#FFF'
            }}>
              {language 
                ? 'Lesson 10 - TDM of Beta-Lactam Antibiotics using the Example of Piperacillin'
                : 'Lektion 10 - TDM von Beta-Lactam-Antibiotika am Beispiel Piperacillin'
              }
            </h3>
            <p style={{ marginBottom: '15px', fontSize: '0.9em' }}>
              {language 
                ? 'Learn how practical considerations for dose adjustments for piperacillin are carried out with PipEasy.'
                : 'Lernen Sie, wie mit PipEasy praxisnah Überlegungen zur Dosisanpassungen für Piperacillin durchgeführt werden.'
              }
            </p>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <YouTubeEmbed
                id="40ycQbBYk_A"
                title={language ? "TDM Piperacillin with PipEasy" : "TDM Piperacillin mit PipEasy"}
                language={language}
              />
            </div>
          </div>

          {/* Lektion 11 */}
          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ 
              fontSize: '1.3em', 
              marginBottom: '10px',
              color: '#FFF'
            }}>
              {language 
                ? 'Lesson 11 - TDM of Beta-Lactam Antibiotics using the Example of Meropenem'
                : 'Lektion 11 - TDM von Beta-Lactam-Antibiotika am Beispiel Meropenem'
              }
            </h3>
            <p style={{ marginBottom: '15px', fontSize: '0.9em' }}>
              {language 
                ? 'Learn how MeroEasy can support you in TDM of meropenem in clinical practice.'
                : 'Lernen Sie, wie MeroEasy Sie beim TDM von Meropenem in der klinischen Praxis unterstützen kann.'
              }
            </p>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <YouTubeEmbed
                id="mNLmTx14sBs"
                title={language ? "TDM Meropenem with MeroEasy" : "TDM Meropenem mit MeroEasy"}
                language={language}
              />
            </div>
          </div>
        </div>

        {/* Hinweis */}
        <div style={{
          backgroundColor: 'rgba(237, 125, 49, 0.2)',
          padding: '20px',
          borderRadius: '10px',
          borderLeft: '5px solid #ED7D31',
          marginTop: '40px'
        }}>
          <p style={{ 
            fontStyle: 'italic',
            fontSize: '0.9em',
            lineHeight: '1.6',
            margin: 0
          }}>
            <strong>{language ? 'Note:' : 'Hinweis:'}</strong> {language 
              ? 'The learning videos do not claim to be complete and do not replace individual clinical assessment. All content was created practically and is intended to support clinical decision-making, not replace it.'
              : 'Die Lernvideos erheben keinen Anspruch auf Vollständigkeit und ersetzen nicht die individuelle klinische Beurteilung. Alle Inhalte wurden praxisnah erstellt und sollen die klinische Entscheidungsfindung unterstützen, nicht ersetzen.'
            }
          </p>
        </div>
      </div>
    </div>
  );
}
